import { render, staticRenderFns } from "./AddSeller.vue?vue&type=template&id=44295876&scoped=true"
import script from "./AddSeller.vue?vue&type=script&lang=js"
export * from "./AddSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44295876",
  null
  
)

export default component.exports